import type { CardDirection, FlowThemeCardMotion } from '../../cardMotion';

/** The card drifts in on the current and floats on downstream, bobbing a little as it goes. */
export const riverCardMotion = (isMobile: boolean): FlowThemeCardMotion => {
  const travel = isMobile ? 46 : 70;
  return {
    variants: {
      enter: (direction: CardDirection) => ({ opacity: 0, x: direction > 0 ? travel : -travel, y: 10, rotate: direction > 0 ? 1.5 : -1.5 }),
      center: { opacity: 1, x: 0, y: 0, rotate: 0 },
      exit: (direction: CardDirection) => ({ opacity: 0, x: direction > 0 ? -travel : travel, y: -8, rotate: direction > 0 ? -1.5 : 1.5 }),
    },
    transition: { duration: 1, ease: [0.33, 1, 0.68, 1] },
  };
};
